module.exports = __webpack_public_path__ + "resources/img/img_coolfilter3.14ae37430e4f7f871bc27f013162f7d8.png";